import React from 'react';
import styled from 'styled-components';
import { breakpoints, padding } from '@com/core/common/styles/baseStyles';
import Link from '@com/core/common/components/Link';

const StaticNavContainer = styled.div`
    padding: 32px ${padding.smWrapperPadding} 40px;
    border-top: 1px solid ${({ theme }): string => theme.colors.border};

    @media ${breakpoints.minDesktop} {
        border-top: 0;
        width: 200px;
        padding: 0;
        background-color: ${({ theme }): string => theme.colors.bgPrimary};
        border-right: 1px solid ${({ theme }): string => theme.colors.border};

        ${({ theme: { colors, isRTL } }): string =>
            isRTL
                ? ` border-left: 1px solid ${colors.border};
                    border-right: 0;`
                : ''}
    }
`;

const CategoryNav = styled.div`
    display: flex;

    @media ${breakpoints.minDesktop} {
        display: block;
    }
`;

type TCategoryProps = {
    borderColor?: string;
};

const Category = styled.div<TCategoryProps>`
    flex: 1;
    @media ${breakpoints.minDesktop} {
        padding: 30px ${padding.smWrapperPadding};
        & + & {
            border-top: 1px solid ${({ borderColor, theme }): string => borderColor || theme.colors.border};
        }
    }
`;

const Title = styled.p`
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    margin-bottom: 10px;
`;

const List = styled.ul``;

type TListItemProps = {
    textColor?: string;
    hoverColor?: string;
};
const ListItem = styled.li<TListItemProps>`
    a {
        padding: 8px 0;
        display: block;
        color: ${({ textColor, theme }): string => textColor || theme.colors.bodyMid};
        font-size: 1.083333rem;
        @media ${breakpoints.minDesktop} {
            &:hover {
                color: ${({ hoverColor, theme }): string => hoverColor || theme.colors.brandSecondary};
            }
        }
    }
`;

type TProps = {
    moduleData: {
        sections: Array<{ title: string; sectionLinks: Array<{ url: string; linkText: string }> }>;
        textColor?: string;
        borderColor?: string;
        hoverColor?: string;
    };
};

const StaticNavigation = ({ moduleData: { borderColor, hoverColor, sections, textColor } }: TProps): JSX.Element => (
    <StaticNavContainer>
        <CategoryNav>
            {sections.map(section => (
                <Category key={section.title} borderColor={borderColor}>
                    <Title>{section.title}</Title>
                    {section.sectionLinks && (
                        <List>
                            {section.sectionLinks.map(link => (
                                <ListItem key={link.url} textColor={textColor} hoverColor={hoverColor}>
                                    <Link href={link.url}>{link.linkText}</Link>
                                </ListItem>
                            ))}
                        </List>
                    )}
                </Category>
            ))}
        </CategoryNav>
    </StaticNavContainer>
);

export default StaticNavigation;
